import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { formatDate } from "utils";
import { Card, CardContent, Typography, Grid } from "@material-ui/core";
import {
	isStaffUser,
	createRowSelector,
	isNotNullOrEmpty,
	isDefaultGuid,
	useTerminology,
} from "utils";
import { CrudOptions, Lookup } from "frame/components";

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		alignItems: "center",
		flexWrap: "wrap",
		position: "relative",
		marginBottom: theme.spacing(2),
		"&:hover": {
			cursor: "pointer",
		},
	},
	container: {
		marginTop: theme.spacing(0.5),
		marginLeft: theme.spacing(1),
	},
	content: {
		padding: theme.spacing(2),
		flexGrow: 1,
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		[theme.breakpoints.down("sm")]: {
			width: "100%",
			flexWrap: "wrap",
		},
		"&:last-child": {
			paddingBottom: theme.spacing(3),
		},
	},
	label: {
		color: "#999999",
	},
}));

const InductionMinutesCard = ({
	inductionMinutes,
	onAppend,
	onEdit,
	onView,
	onDelete,
	onEmail,
	role,
}) => {
	const classes = useStyles();
	const { siteLabel } = useTerminology();
	const onRowSelect = createRowSelector(onView);
	const id = {
		id: inductionMinutes.id,
		form: "induction-minutes",
	};
	const displayTotalHazardsSubstances = () => {
		let total = isNotNullOrEmpty(inductionMinutes.hazards)
			? inductionMinutes.hazards.length
			: 0;
		total += isNotNullOrEmpty(inductionMinutes.hazardousSubstances)
			? inductionMinutes.hazardousSubstances.length
			: 0;
		return total;
	};

	return (
		<Card className={classes.root} onClick={onRowSelect}>
			<CardContent className={classes.content}>
				<Grid className={classes.container} container spacing={2}>
					<Grid item md={3} sm={6} xs={6}>
						<Typography variant="body2" className={classes.label}>
							{siteLabel} Name
						</Typography>
						<Typography variant="h5">
							<Lookup
								id={inductionMinutes.siteId}
								resource="sites"
								attribute="siteName"
							/>
						</Typography>
					</Grid>
					<Grid item md={3} sm={6} xs={6}>
						<Typography variant="body2" className={classes.label}>
							Created
						</Typography>
						<Typography variant="h5">
							{formatDate(inductionMinutes.createdAt)}
						</Typography>
					</Grid>
					<Grid item md={1} sm={6} xs={6}>
						<Typography variant="body2" className={classes.label}>
							People
						</Typography>
						<Typography variant="h5">
							{isNotNullOrEmpty(
								inductionMinutes.people.filter(
									(p) => !isDefaultGuid(p.id)
								)
							)
								? inductionMinutes.people.filter(
										(p) => !isDefaultGuid(p.id)
								  ).length
								: "-"}
						</Typography>
					</Grid>
					<Grid item md={2} sm={6} xs={6}>
						<Typography variant="body2" className={classes.label}>
							Other People
						</Typography>
						<Typography variant="h5">
							{isNotNullOrEmpty(
								inductionMinutes.people.filter((p) =>
									isDefaultGuid(p.id)
								)
							)
								? inductionMinutes.people.filter((p) =>
										isDefaultGuid(p.id)
								  ).length
								: "-"}
						</Typography>
					</Grid>
					<Grid item md={2} sm={6} xs={6}>
						<Typography variant="body2" className={classes.label}>
							Hazards/Substances
						</Typography>
						<Typography variant="h5">
							{displayTotalHazardsSubstances()}
						</Typography>
					</Grid>
					<div className="ignore">
						{!isStaffUser(role) && (
							<CrudOptions
								onAppend={onAppend}
								onView={onView}
								onDelete={() => onDelete(id)}
								onEmail={onEmail}
							/>
						)}
					</div>
				</Grid>
			</CardContent>
		</Card>
	);
};

InductionMinutesCard.propTypes = {
	inductionMinutes: PropTypes.object.isRequired,
	onAppend: PropTypes.func.isRequired,
	onEdit: PropTypes.func.isRequired,
	onDelete: PropTypes.func.isRequired,
	onView: PropTypes.func.isRequired,
	role: PropTypes.string.isRequired,
};

export default InductionMinutesCard;
